export const phone = '400-688-9268';

export default {
  phone,
};
